import React, { useId, useState } from "react";
import { useTranslation } from "react-i18next";
import "./FAQ.css";

export default function FAQItem({ question, answer }) {
  const [expanded, setExpanded] = useState(false);
  const { i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  const panelId = useId();

  return (
    <div
      style={{
        paddingTop: "20px",
        paddingBottom: "20px",
        marginBottom: "0px",
        borderBottom: "1px solid var(--seperator-color)",
      }}
    >
      <button
        type="button"
        className="faq-question"
        onClick={() => setExpanded(!expanded)}
        aria-expanded={expanded}
        aria-controls={panelId}
        style={{
          width: "100%",
          gap: "10px",
          textAlign: "start",
          padding: "10px 0",
          fontSize: "1.1rem",
          fontWeight: "400",
          background: "none",
          border: "none",
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          color: "inherit",
        }}
      >
        <span>{question}</span>
        <span className="faq-icon" aria-hidden="true" style={{ fontSize: "1.2rem" }}>
          {expanded ? "–" : "+"}
        </span>
      </button>
      {expanded && (
        <div
          id={panelId}
          className="faq-answer"
          style={{
            padding: "0 0 10px",
            textAlign: isRTL ? "right" : "left",
            lineHeight: "1.6",
          }}
        >
          {answer}
        </div>
      )}
    </div>
  );
}
